import useSWR from "swr";
import { swrKey } from "@/lib/swr";

// A tag from the global vocabulary. `color` is a Tailwind dot class (e.g. "bg-blue-500")
// or undefined — when absent the UI falls back to a name-hashed color (tagDotColor).
export interface TagItem {
  id: number;
  name: string;
  color?: string;
  count?: number;
  members?: TagPerson[];
}

// Display shape for a tag's members (subset of the server User entity).
export interface TagPerson {
  id: string;
  name?: string;
  avatarThumb?: string;
}

// Global vocabulary of PRD tags (for the label editor's type-ahead). Tags are a
// cross-cutting free-form dimension with no team/workspace scope — a single global
// list across all PRDs, sorted by usage frequency, with usage counts.
export const useTags = (): TagItem[] => {
  const { data } = useSWR<TagItem[]>(["/tags"]);
  return data || [];
};

// Tags the current user joined — drives the sidebar "Labels" group.
// Server-side membership (tag_member) replaced the old local pinned-tags
// store, so the list follows the user across devices.
export const useMyTags = (): TagItem[] => {
  const { data } = useSWR<TagItem[]>(swrKey("/tags", { mine: 1 }));
  return data || [];
};
